/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { EventBinder } from '@appPlanApplication/interaction';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { DisplayObject, Point } from 'pixi.js-legacy';
import { IDestroyOptions } from '@appCanvasCommon/core/DestroyOptions';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
import { CursorType } from '@appCanvasCommon/events/cursor-type.enum';
import { Ticket } from '@touchplan/common';
import { TimelineDisplayItem } from '@appPlanApplication/timeline/tickets/TimelineDisplayItem';
import { ITimelineTicketDisplayItem } from '@appPlanApplication/timeline/TimelineHelpers';
import { cssVar } from '@touchplan/css-var';

const settings = {
	yOffset: 32, // Arbitrary offset from old code
};

export class TimelineTicketTap extends Component implements ComponentInterface {
	private _binder: EventBinder;
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, parent: DisplayObject): void {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(parent);
		parent.eventMode = EventMode.Static;
		parent.cursor = CursorType.Pointer;

		this._binder.add('hammer-singletap', (event) => {
			const parent: TimelineDisplayItem<ITimelineTicketDisplayItem> =
				this.getParent() as TimelineDisplayItem<ITimelineTicketDisplayItem>;
			const tickets: Ticket[] = parent.data.tickets;
			canvasAngularLand.timelineTicketService.openOverflow(
				new Point(event.center.x, cssVar.headerHeight_px + cssVar.timelineHeight_px + settings.yOffset),
				tickets
			);
		});
	}

	public override destroy(opts?: IDestroyOptions) {
		super.destroy(opts);
		this._binder.destroy();
	}
}
